import { InjectionToken } from '@angular/core';

export interface UzurvApiConfiguration {
  claraApiUrl: string;
  httpDebugMode: boolean;
}

export const UZURV_API_CONFIGURATION = new InjectionToken<UzurvApiConfiguration>('UzurvApiConfiguration');

// The environment file isn't defined correctly for this in the crm
// export function getUzurvApiConfiguration(): UzurvApiConfiguration {
//   return {
//     claraApiUrl: environment.claraApiUrl,
//     httpDebugMode: environment.enableHttpRequestLogging
//   };
// }
